import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NavBar = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen((prev) => !prev);

  return (
    <div className="relative">
      {/* Top bar */}
      <div onClick={toggleMenu} className="rounded-xl text-sm font-medium border border-orange-400 bg-gray-800 text-white px-10 py-2 hover:bg-gray-700 transition-all duration-200 hover:bg-orange-400 hover:text-black">
        <div className="flex items-center gap-2 cursor-pointer">
        <span className="text-lg font-semibold">Nav</span>
        {isOpen ? <X size={24} /> : <Menu size={24} />}
        </div>
      </div>

      {/* Animated dropdown */}
      <div
        className={`absolute right-0 mt-2 bg-darkgray border border-orange-400 rounded shadow-lg p-4 flex flex-col gap-2 min-w-[120px] z-50
          transition-all duration-300 ease-out origin-top-right
          ${isOpen ? 'opacity-100 scale-100' : 'opacity-0 scale-95 pointer-events-none'}
        `}
      >
        <Link to="/" onClick={() => setIsOpen(false)} className="hover:font-bold text-lg font-medium px-10 py-2">Home</Link>
        <Link to="/About" onClick={() => setIsOpen(false)} className="hover:font-bold text-lg font-medium px-10 py-2">About</Link>
        <Link to="/Gallery" onClick={() => setIsOpen(false)} className="hover:font-bold text-lg font-medium px-10 py-2">Gallery</Link>
        <Link to="/Contact" onClick={() => setIsOpen(false)} className="hover:font-bold text-lg font-medium px-10 py-2">Contact</Link>
      </div>
    </div>
  );
};

export default NavBar;
